export enum RuntimeEnvironment {
  Development = 'development',
  Staging = 'staging',
  Production = 'production'
}

const knownEnvironments = new Set<string>(Object.values(RuntimeEnvironment))

export function getRuntimeEnvironment(): RuntimeEnvironment {
  const configuredEnvironment = process.env.REACT_APP_ENVIRONMENT?.toLowerCase()

  if (configuredEnvironment && knownEnvironments.has(configuredEnvironment))
    return configuredEnvironment as RuntimeEnvironment

  return RuntimeEnvironment.Production
}

/**
 * Returns the environment compiled into the current client bundle.
 * It is intentionally stable for the lifetime of the application.
 */
export function useRuntimeEnvironment(): RuntimeEnvironment {
  return getRuntimeEnvironment()
}
